/* 🤖 this file was generated by svg-to-ts */
export const siriusRuler: {
  name: 'ruler';
  data: string;
} = {
  name: 'ruler',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 14.685a1.5 1.5 0 0 0 0 2.121l4.94 4.94a1.5 1.5 0 0 0 2.121 0L21.747 9.309a1.5 1.5 0 0 0 0-2.121l-4.94-4.94a1.5 1.5 0 0 0-2.12 0L2.25 14.686Zm11.184-9.062 2.313-2.314 4.94 4.94L8.25 20.685l-4.939-4.94 2.312-2.311 2.472 2.471a.75.75 0 0 0 1.06-1.06l-2.471-2.472 2.314-2.314 2.472 2.471a.75.75 0 1 0 1.06-1.06L10.06 8.998l2.314-2.314 2.472 2.471a.75.75 0 1 0 1.06-1.06l-2.471-2.472Z" fill="currentColor"/></svg>`
};
